import React, { useState } from "react";
import { Card, CardBody, Button } from "reactstrap";
import { Divider, List } from "antd";

import TicketsTable from "./ticketsTable";
import { Link } from "react-router-dom";
import { gql, useQuery } from "@apollo/client";
import Loader from "../../Loader";
import { error } from "../../Controllers/toast";
import { useSelector } from "react-redux";

const TICKET_LIST_SCHEMA = gql`
  query ($page: Int) {
    GetTickets(page: $page) {
      _count
      tickets {
        categorie
        created
        source
        status
        ticket_id
        title
        user {
          User {
            firstname
            lastname
            role
          }
        }
      }
    }
  }
`;

const Tickets = () => {
  const lang_choiced = useSelector((state) => state.lang_change);
  const [page, setPage] = useState(0);
  // const [ticketsList, setTicketList] = useState([]);
  const { data, loading ,refetch} = useQuery(TICKET_LIST_SCHEMA, {
    onCompleted: (res) => {
      // console.log(res);
      // setTicketList(res.GetTickets);
    },
    onError: (err) => {
      error("مشکلی در دریافت تیکت ها رخ داده است!")
      // console.log(err);
    },
    variables: {
      page,
    },
    fetchPolicy:"network-only"
  });
  if (loading) return <Loader />;
  else
    return (
      <div className="animated fadeIn">
        <Card className="p-4" style={{ minHeight: "50vh" }}>
          <Divider>
            <h3>{lang_choiced.pages.tickets.title}</h3>
          </Divider>
          <CardBody>
            <div className="mb-3">
              <Link to="ticket/create">
                <Button color="success">{lang_choiced.pages.tickets.btnNewTicket}</Button>
              </Link>
            </div>
            <TicketsTable
              setPage={(e) => setPage(e)}
              count={data.GetTickets._count}
              data={data.GetTickets.tickets}
              loading={loading}
              page={page}
              // refetchTicketsList={refetch()}
            />
          </CardBody>
        </Card>
        {/* <Card className="p-4" style={{ minHeight: "50vh" }}>
        <List
          bordered
          size="large"
          dataSource={ticketsList}
          renderItem={(ticket) => {
            let date = new Date(parseInt(ticket.date));
            const cat = (categorie) => {
              switch (categorie) {
                case "info":
                  return "اطلاعات";
                case "sales":
                  return "فروش";
                case "other":
                  return "غیره";
                default:
                  return "نامشخص";
              }
            };
            return (
              <List.Item>
                <List.Item.Meta
                  title={
                    <span>
                      عنوان: <b>{ticket.title}</b>
                    </span>
                  }
                  description={
                    <span>
                      <b>تاریخ ارسال :</b> {date.toLocaleDateString()}
                      <Divider type="vertical" />
                      دسته بندی : {cat(ticket.cat)}
                    </span>
                  }
                />
                <Button type="link">مشاهده تیکت</Button>
              </List.Item>
            );
          }}
        ></List>
      </Card> */}
      </div>
    );
};

export default Tickets;
